import { render } from "./WeeklyRewardsModal.vue?vue&type=template&id=1ed79836&scoped=true"
import script from "./WeeklyRewardsModal.vue?vue&type=script&lang=js"
export * from "./WeeklyRewardsModal.vue?vue&type=script&lang=js"

import "./WeeklyRewardsModal.vue?vue&type=style&index=0&id=1ed79836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed79836"]])

export default __exports__